namespace RioERP.Invoices {
    export interface InvoiceNumberFormatForm {
        InvoiceCompanyId: Serenity.LookupEditor;
        SourceTypeId: Serenity.LookupEditor;
        CurrencyId: Serenity.LookupEditor;
        InvoicePrefix: Serenity.StringEditor;
        MonthlyReset: Serenity.BooleanEditor;
        ResetDate: Serenity.DateEditor;
        Part1: Serenity.EnumEditor;
        Part2: Serenity.EnumEditor;
        Part3: Serenity.EnumEditor;
        Part4: Serenity.EnumEditor;
        AutoIncrementLimit: Serenity.StringEditor;
    }

    export class InvoiceNumberFormatForm extends Serenity.PrefixedContext {
        static formKey = 'Invoices.InvoiceNumberFormat';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InvoiceNumberFormatForm.init)  {
                InvoiceNumberFormatForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DateEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(InvoiceNumberFormatForm, [
                    'InvoiceCompanyId', w0,
                    'SourceTypeId', w0,
                    'CurrencyId', w0,
                    'InvoicePrefix', w1,
                    'MonthlyReset', w2,
                    'ResetDate', w3,
                    'Part1', w4,
                    'Part2', w4,
                    'Part3', w4,
                    'Part4', w4,
                    'AutoIncrementLimit', w1
                ]);
            }
        }
    }
}
